<template>
    <FullCalendar :options="calendarOptions" />
</template>
<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import listPlugin from '@fullcalendar/list'
import esLocale from '@fullcalendar/core/locales/es';

export default {
    name: 'CalendarSummary',
    components: {
        FullCalendar // make the <FullCalendar> tag available
    },
    data() {
        return {            
            calendarOptions: {
                //slotDuration: '24:00',     
                //height: "100%",
                locale: esLocale,           
                events: [],
                plugins: [
                    dayGridPlugin,
                    timeGridPlugin,
                    listPlugin,
                    interactionPlugin // needed for dateClick
                ],
                eventClick: this.handleEventClick,
                dateClick: this.handleDateClick,
                headerToolbar: {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'dayGridMonth,listWeek'
                },
                initialView: 'listWeek',            
            visibleRange: function(currentDate) {
                // Generate a new date for manipulating in the next step
                var startDate = new Date(currentDate.valueOf());
                var endDate = new Date(currentDate.valueOf());

                // Adjust the start & end dates, respectively
                startDate.setDate(startDate.getDate() - 365); // One day in the past
                endDate.setDate(endDate.getDate() + 365); // Two days into the future

                return { start: startDate, end: endDate };
                }
            }
        }
    },
    methods: {
        handleEventClick: function(event) {
            console.log(event.event.startStr);
            this.$router.push('agenda');
            setTimeout(() => {
                this.$store.state.refCalendar.getApi().gotoDate(event.event.startStr);    
            }, 200);
            
        },
        handleDateClick: function(event) {
            console.log(event.dateStr);
            this.$router.push('agenda');
            setTimeout(() => {
                this.$store.state.refCalendar.getApi().gotoDate(event.dateStr);    
            }, 200);
            
        }
        /*handleEventClick: function(event) {
            /*var start = event.event.start;
            start = new Date(start.valueOf() - start.getTimezoneOffset() * 60000); 
            //Ajuste para GMT+1 / 0 entre la app y Nav
            this.$store.commit('saveDocumentDate',start);
            //if (event.event.title == 'Pulse para añadir un parte'){                
            if (event.event.extendedProps.newInput){
                //this.$store.state.dialogParte = true;
                this.$store.commit('resetDataAfterSuccessfulCreation');
                this.$router.push('Parte');
                this.$store.state.dialogConfirmDriver = true;
            } else {
                var docNo = event.event.extendedProps.inputNo;
                this.readDocument(docNo);
                //this.$store.state.dialogParteDetalle = true;
                this.$router.push('ParteDetalle');
            }
        }*/
    },
    watch:{
        eventos: function(val){
            
            var events = [];
            var today = new Date();                   
            var startDate = new Date(today.valueOf());
            //var sinceMonths = 5;
            var sinceMonths = 12;
            var sinceDays = sinceMonths*30;
            //var toMonths = 2;
            //var toDays = toMonths*30;
            startDate.setDate(startDate.getDate() - sinceDays);

            /*for (var i = 0; i <= sinceDays+toDays; i++){ 
                var eventDate = new Date(startDate); 
                eventDate.setDate(eventDate.getDate() + i);                    
                var backgroundColor = '';
                var textColor = '';
                var borderColor = '';
                if (i == sinceDays){ //Dia actual
                    backgroundColor = 'green';
                }
                var event = {
                    id: i, 
                    title: 'x', 
                    date: eventDate,                 
                    allDay: true, 
                    backgroundColor: backgroundColor, 
                    textColor: textColor,
                    borderColor: borderColor,
                    newInput : true
                }
                events.push(event);            
            }*/
            this.calendarOptions.events = events;
            if ((val != null) && (val != undefined) && (val.length > 0)){
                for (var i = 0; i < val.length; i++){
                    var title = parseFloat(val[i].timeCount).toFixed(2) + ' ';
                    var color = 'red';
                    if (parseFloat(val[i].timeCount) == 8) color = 'green';
                    if (parseFloat(val[i].timeCount) > 8) color = 'orange';
                    if (val[i].reten){
                        title += 'Reten';
                        color = 'purple';
                    } else if(val[i].curso){
                        if (val[i].uom == '1') {
                            title += 'Curso Extra';
                        } else {
                            title += 'Curso';
                        }
                        color = '#000080';
                    } else {
                        if (val[i].uom == '1') {
                            title += 'Extra';
                            color = 'blue';
                        }
                    }
                    var event = {
                        id: this.calendarOptions.events.length, 
                        title: title, 
                        date: val[i].postingDate,                 
                        allDay: true, 
                        backgroundColor: color,
                        inputNo : '',
                        shipmentNo : '',
                        newInput : false
                    }
                    this.calendarOptions.events.push(event);
                }
            }
        }
    },
    computed:{
        eventos:{
            get(){
                return this.$store.state.eventos;
            },
            set(value){
                this.$store.commit('saveEvents',value);
            }
        }        
    },
    mounted(){
        /*var events = [];
        var today = new Date();
        var startDate = new Date(today.valueOf());
        startDate.setDate(startDate.getDate() - 3);
        for (var i = 0; i <= 15; i++){ 
            var eventDate = new Date(startDate); 
            eventDate.setDate(eventDate.getDate() + i);                    
            var backgroundColor = '';
            var textColor = '';
            var borderColor = '';
            if (i == 3){
                backgroundColor = 'green';
            }
            var event = {
                id: i, 
                title: 'Pulse para añadir un parte', 
                date: eventDate,                 
                allDay: true, 
                backgroundColor: backgroundColor, 
                textColor: textColor,
                borderColor: borderColor
            }
            events.push(event);            
        }*/
        this.getJobInputSummary();
        //this.calendarOptions.events = events;
    }
}
</script>
<style >
    .fc-list-event-time{display: none}
    .fc-toolbar-title{
        font-size: 10pt;
    }
    .fc .fc-toolbar-title{
        font-size: 0.7em;
    }
    .fc-event-today{
        background-color: bisque;
    }
</style>